import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { TranslatedVariables } from 'src/app/commons/translated-variables';
import { LoginService } from 'src/app/core/services/login.service';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { YesNoDialogComponent } from 'src/app/store/dialogs/yes-no-dialog/yes-no-dialog.component';
import { UserData } from '../../account-management/account-management.component';

@Component({
    selector: 'ms-account-table',
    templateUrl: './account-table.component.html',
    styleUrls: ['./account-table.component.scss'],
})
export class AccountTableComponent implements OnInit, OnChanges {
    @Input() userFound: boolean;
    @Input() searchUser: string;
    @Input() showFilterOptions: boolean;
    @Input() dataSourceUser: MatTableDataSource<UserData>;
    @Output() showTabsEvent = new EventEmitter<any>();
    @Output() doSomethingEvent = new EventEmitter<any>();
    @Output() showTabCreationAccountEvent = new EventEmitter<any>();
    @Output() applyFilter = new EventEmitter<string>();
    displayedColumnUser: string[] = ['Users'];
    isComponentInitialized = false;
    _paginatorUsers: MatPaginator;
    indexAccountSelected: number;

    @ViewChild('paginatorUsers') set paginatorUsers(contentAccounts: MatPaginator) {
        if (contentAccounts) {
            // initially setter gets called with undefined
            this._paginatorUsers = contentAccounts;
            const paginatorIntl = this._paginatorUsers._intl;
            paginatorIntl.nextPageLabel = this.variable.nextPage;
            paginatorIntl.previousPageLabel = this.variable.previousPage;
            if (this.dataSourceUser) {
                this.dataSourceUser.paginator = this._paginatorUsers;
            }
        }
    }

    constructor(
        private dialog: MatDialog,
        private variable: TranslatedVariables,
        private workFlow: WorkFlowService,
        private loginService: LoginService
    ) {}

    ngOnInit(): void {
        this.isComponentInitialized = true;
    }

    ngOnChanges() {
        if (this.isComponentInitialized) {
            this.dataSourceUser.paginator = this._paginatorUsers;
            this.getPageIndexOfAccountSelected();
        }
    }

    getPageIndexOfAccountSelected() {
        let userData = this.dataSourceUser.data.find((x) => x.IsClicked);
        this.indexAccountSelected = this.dataSourceUser.data.indexOf(userData);
        this.dataSourceUser.paginator.pageIndex = Math.floor(this.indexAccountSelected / this.dataSourceUser.paginator.pageSize);
    }

    clearUserSearch() {
        this.searchUser = '';
        this.dataSourceUser.filter = this.searchUser.trim().toLowerCase();
        this.userFound = true;
        this.showFilterOptions = true;
    }

    resetPwd(accountName: string) {
        const dlgAsk = this.dialog.open(YesNoDialogComponent, {
            data: {
                Title: this.variable.dialogAccount_2,
                Message: `${this.variable.dialogAccount_3} ${accountName}?`,
                Result: true,
            },
        });

        dlgAsk.afterClosed().subscribe((resAskDlg) => {
            if (!resAskDlg) {
                return;
            } else if (resAskDlg.Result) {
                this.resetPassword(accountName);
                return;
            }
        });
    }

    reactivate(accountName: string) {
        const dlgAsk = this.dialog.open(YesNoDialogComponent, {
            data: {
                Title: this.variable.dialogAccount_4,
                Message: `${this.variable.dialogAccount_4} ${accountName}?`,
                Result: true,
            },
        });
        dlgAsk.afterClosed().subscribe((resAskDlg) => {
            if (!resAskDlg) {
                return;
            } else if (resAskDlg.Result) {
                this.parentAccountResendMail(accountName);
                return;
            }
        });
    }

    parentAccountResendMail(accountName: string) {
        const resetPassword = this.loginService.resendMail(accountName).subscribe(
            (changeResult) => {
                if (!changeResult.Result) {
                    this.workFlow.showMessage(this.variable.errorResendMail, changeResult.Message);
                }
                this.workFlow.showSnackBar(this.variable.operationSucceeded);
                resetPassword.unsubscribe();
            },
            (changeError) => {
                this.workFlow.showMessage(this.variable.errorResendMail, changeError.message);
                resetPassword.unsubscribe();
            }
        );
    }

    resetPassword(accountName: string) {
        const resetPassword = this.loginService.resetPassword(accountName).subscribe(
            (changeResult) => {
                if (!changeResult.Result) {
                    this.workFlow.showMessage(this.variable.errorResetPass, changeResult.Message);
                }
                this.workFlow.showSnackBar(this.variable.operationSucceeded);
                resetPassword.unsubscribe();
            },
            (changeError) => {
                this.workFlow.showMessage(this.variable.errorResetPass, changeError.message);
                resetPassword.unsubscribe();
            }
        );
    }

    onClickShowTabs(row: any) {
        this.showTabsEvent.emit(row);
    }

    onClickDoSomething(something: any) {
        this.doSomethingEvent.emit(something);
    }

    onClickShowTabCreationAccount() {
        this.showTabCreationAccountEvent.emit();
    }

    onClickApplyFilter(event: string) {
        this.applyFilter.emit(event);
    }
}
